/**
 * PRÓXIMAS VISTORIAS
 * Fonte: /api/vistorias/listar.php
 */
import React, { useEffect, useState } from 'react';
import { Loader2, MapPin, Calendar } from 'lucide-react';

export default function VistoriasCard() {
  const [vistorias, setVistorias] = useState([]);
  const [loading, setLoading]     = useState(true);

  useEffect(() => {
    fetch('/api/vistorias/listar.php', { credentials: 'include' })
      .then(r => r.json())
      .then(d => { if (d.success) setVistorias(d.vistorias || []); })
      .catch(err => console.error('[Vistorias]', err))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="bg-[#0A0F1E] border border-white/[0.06] rounded-2xl p-6 flex justify-center">
        <Loader2 className="animate-spin text-blue-400" size={20} />
      </div>
    );
  }

  return (
    <div className="bg-[#0A0F1E] border border-white/[0.06] rounded-2xl p-6">

      <div className="mb-6">
        <h3 className="text-[10px] font-bold text-blue-400 uppercase tracking-[0.2em]">
          Próximas Vistorias
        </h3>
        <p className="text-[9px] text-slate-500 uppercase tracking-wider mt-1">
          Agenda de campo
        </p>
      </div>

      {vistorias.length === 0 ? (
        <div className="text-center py-8">
          <MapPin size={32} className="mx-auto text-slate-700 mb-3" />
          <p className="text-slate-500 text-xs">Nenhuma vistoria agendada.</p>
        </div>
      ) : (
        <div className="space-y-2 max-h-[320px] overflow-y-auto pr-1">
          {vistorias.slice(0, 10).map(v => (
            <div
              key={v.id}
              className="p-3 rounded-xl bg-white/[0.02] border border-white/[0.04]"
            >
              <div className="flex items-start justify-between gap-3 mb-2">
                <p className="text-white font-bold text-xs uppercase truncate">
                  {v.titulo || `Vistoria #${v.id}`}
                </p>
                <span className="text-[9px] font-bold text-blue-400 uppercase tracking-widest shrink-0">
                  {v.status || '—'}
                </span>
              </div>
              {v.data_agendada && (
                <div className="flex items-center gap-2 text-slate-500 text-[10px]">
                  <Calendar size={11} />
                  <span>{new Date(v.data_agendada).toLocaleString('pt-BR')}</span>
                </div>
              )}
              {v.endereco && (
                <div className="flex items-center gap-2 text-slate-500 text-[10px] mt-1">
                  <MapPin size={11} />
                  <span className="truncate">{v.endereco}</span>
                </div>
              )}
            </div>
          ))}
        </div>
      )}

    </div>
  );
}